<main class="attendance-page">
  <header class="brand"><img src="assets/logo.png" alt="UNION NEST"></header>
  <section class="attendance-card" aria-live="polite">
    @if (showSpinner && !state) {
      <div class="loading"><mat-spinner diameter="44"></mat-spinner></div>
    } @else if (errorMessage && !state) {
      <h1>出欠確認</h1>
      <p class="error">{{ errorMessage }}</p>
      <button mat-stroked-button [disabled]="showSpinner" (click)="load()">最新の状態を取得</button>
      <button mat-stroked-button (click)="goToMyEvent()">MYイベントへ</button>
    } @else if (state) {
      <p class="eyebrow">出欠確認</p>
      <h1>{{ state.title }}</h1>
      @if(state.brochure){<p><a [href]="state.brochure.url" target="_blank" rel="noopener">開催パンフレットを見る（PDF）</a></p>}
      @if(state.brochureNotice){<p class="operation-notice">{{state.brochureNotice}}</p>}
      @if (state.scheduleNeedsUpdate) { <p class="error">開催日程を確認中です。出席登録は担当者が開催日を設定した後に利用できます。</p> }
      <div class="session-schedule">@for (session of state.sessions; track $index) { <p class="deadline">{{ formatSession(session.start,session.end) }}</p> }</div>

      @if (state.operationNotice) {
        <p class="operation-notice" role="status">{{ state.operationNotice }}</p>
        <button mat-stroked-button [disabled]="showSpinner" (click)="load()">最新の状態を取得</button>
      } @else if (state.dailyAttendance.length === 1 && !state.dailyAttendance[0].included) {
        <p>この開催日は参加対象外です。</p>
      } @else if (state.phase === 'answer' && state.dailyAttendance.length > 1) {
        <p class="instruction">開催日ごとに出欠を回答してください。</p>
        @for (day of state.dailyAttendance; track day.date) {
          <section class="day-answer">
            <h2>{{ dayLabel(day.date) }}</h2>
            @if (day.included) {
              <p>現在の回答：<strong>{{ plannedLabel(day.plannedStatus) }}</strong></p>
              <div class="choice-buttons">
                <button mat-flat-button class="primary" [attr.aria-pressed]="day.plannedStatus === 'attending'" [disabled]="showSpinner || !day.canAnswer" (click)="answer('attending',day.date)">出席予定</button>
                <button mat-stroked-button [attr.aria-pressed]="day.plannedStatus === 'absent'" [disabled]="showSpinner || !day.canAnswer" (click)="answer('absent',day.date)">欠席予定</button>
              </div>
            } @else { <p>この日は参加対象外です。</p> }
          </section>
        }
        <p class="deadline">回答期限 {{ formatDate(state.answerDeadline) }}</p>
      } @else if (state.phase === 'answer') {
        <p class="instruction">{{ state.plannedStatus === 'unanswered' ? '出欠を回答してください' : '変更する場合は選び直してください。' }}</p>
        <div class="choice-buttons">
          <button mat-flat-button class="primary" [disabled]="showSpinner" (click)="answer('attending')">出席予定</button>
          <button mat-stroked-button [disabled]="showSpinner" (click)="answer('absent')">欠席予定</button>
        </div>
        @if (state.plannedStatus !== 'unanswered') {
          <p class="current-answer">現在の回答：<strong>{{ plannedLabel() }}</strong></p>
        }
        <p class="deadline">回答期限 {{ formatDate(state.answerDeadline) }}</p>
      } @else if (state.phase === 'checkin') {
        @if (state.attendanceDate) { <p class="today-heading">{{ dayLabel(state.attendanceDate) }}の出席受付</p> }
        @if (todayExcluded) {
          <p>本日は参加対象外です。</p>
        } @else if (state.actualStatus === 'attended') {
          <div class="complete-mark" aria-hidden="true">✓</div>
          <h2>出席済み</h2>
          <p>{{ formatDate(state.actualAt) }}に登録しました</p>
        } @else {
          <p class="current-answer">現在の予定：<strong>{{ plannedLabel() }}</strong></p>
          <button mat-flat-button class="primary checkin" [disabled]="showSpinner || !state.canCheckIn" (click)="checkIn()">{{ state.attendanceMode === 'daily' ? '本日の出席を登録する' : '出席登録する' }}</button>
        }
      } @else if (state.phase === 'finished') {
        <h2>{{ state.attendanceMode !== 'daily' && state.actualStatus === 'attended' ? '出席済み' : '開催終了' }}</h2>
        @if (state.actualStatus === 'attended') {
          <p>{{ formatDate(state.actualAt) }}に登録しました</p>
        }
      } @else {
        <p class="current-answer">現在の回答：<strong>{{ plannedLabel() }}</strong></p>
        <p>現在は受付時間外です。各開催日の受付開始後、この画面から出席登録できます。</p>
        <button mat-stroked-button [disabled]="showSpinner" (click)="load()">最新の状態を取得</button>
      }

      @if (state.dailyAttendance.length > 1 && state.phase !== 'answer') {
        <div class="daily-attendance"><h3>開催日ごとの登録状況</h3>
          @for (day of state.dailyAttendance; track day.date) { <div [class.attended]="day.included && day.actualStatus === 'attended'"><span>{{ dayLabel(day.date) }}<small>{{ day.included ? plannedLabel(day.plannedStatus) : '参加対象外' }}</small></span><strong>{{ day.included ? actualLabel(day.actualStatus) : '対象外' }}</strong></div> }
        </div>
      }

      @if (errorMessage) {
        <p class="error" role="alert">{{ errorMessage }}</p>
        <button mat-stroked-button [disabled]="showSpinner" (click)="load()">最新の状態を取得</button>
      }
      @if (showSpinner) { <div class="inline-loading"><mat-spinner diameter="28"></mat-spinner></div> }
    }
    @if(surveyLink?.url){<button mat-raised-button (click)="openSurvey()">アンケートに回答</button>}
  </section>
</main>
